<template>
  <div class="traslado-envios">
    <v-btn small outlined :disabled="disabled || !cajaId || !numeroViaje" @click="abrir">
      <v-icon left small>mdi-swap-horizontal</v-icon>Mover a otro viaje
    </v-btn>
    <v-btn small outlined :disabled="disabled || !cajaId || !numeroViaje" @click="verHistorial(0)">
      <v-icon left small>mdi-history</v-icon>Historial de traslados
    </v-btn>
    <span v-if="mensaje" role="status">{{ mensaje }}</span>
    <v-dialog v-model="visible" max-width="980" persistent scrollable>
      <v-card>
        <v-card-title class="traslado-titulo">Mover a otro viaje<v-spacer />
          <v-btn icon :disabled="guardando" aria-label="Cerrar" title="Cerrar" @click="cerrar"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-progress-linear v-if="cargando || guardando" indeterminate />
        <v-card-text>
          <v-alert v-if="error" type="error" outlined dense role="alert">{{ error }}</v-alert>
          <v-alert v-if="incierta" type="warning" outlined dense>Resultado pendiente de confirmar. Reintentar consulta la misma solicitud.</v-alert>
          <div class="traslado-origen">Viaje origen: <strong>{{ origen }}</strong></div>
          <div class="traslado-lista">
            <table>
              <thead><tr><th><input type="checkbox" aria-label="Seleccionar todos los envios disponibles" :checked="todos" :disabled="bloqueado || !elegibles.length" @change="seleccionarTodos($event.target.checked)"></th><th>Envio</th><th>Descripcion</th><th>Asientos</th><th>Estado</th></tr></thead>
              <tbody><tr v-for="envio in envios" :key="envio.id">
                <td><input v-model="seleccion" type="checkbox" :value="envio.id" :disabled="bloqueado || !!impedimento(envio)" :aria-label="'Seleccionar envio ' + envio.no_envio"></td>
                <td>{{ envio.no_envio }}</td><td>{{ envio.descripcion }}</td><td>{{ envio.asientos }}</td><td>{{ impedimento(envio) || 'Disponible' }}</td>
              </tr><tr v-if="!envios.length"><td colspan="5">{{ cargando ? 'Cargando...' : 'Sin envios en este viaje.' }}</td></tr></tbody>
            </table>
          </div>
          <p class="my-3">{{ seleccion.length }} envio(s) seleccionados · {{ asientos }} boleto(s) por asiento</p>
          <div class="traslado-destino">
            <v-text-field v-model="fecha" type="date" label="Fecha destino" outlined dense hide-details :disabled="bloqueado" @change="buscarDestinos" />
            <v-select v-model="destinoId" :items="destinos" item-value="id" :item-text="etiquetaDestino" label="Viaje destino" placeholder="Seleccione viaje" outlined dense hide-details :disabled="bloqueado || buscando" :loading="buscando" no-data-text="Sin viajes abiertos del mismo sentido" @change="confirmando = false" />
          </div>
          <div v-if="destino" class="my-3">Ficha: <strong>{{ destino.ficha }}</strong> · Chofer: <strong>{{ destino.chofer }}</strong> · Hora: {{ destino.hora }}</div>
          <v-textarea v-model="motivo" class="mt-4" label="Motivo obligatorio" outlined rows="2" maxlength="1000" counter="1000" :disabled="bloqueado" @input="confirmando = false" />
          <v-alert v-if="confirmando" type="warning" outlined>
            ¿Mover {{ seleccion.length }} envio(s) y {{ asientos }} boleto(s) de {{ origen }} a {{ destino && destino.viaje }}, ficha {{ destino && destino.ficha }}?
          </v-alert>
        </v-card-text>
        <v-card-actions class="traslado-acciones"><v-spacer />
          <v-btn text :disabled="guardando" @click="cerrar">Volver</v-btn>
          <v-btn color="primary" :loading="guardando" :disabled="cargando || buscando || (!incierta && (!seleccion.length || !destino || motivo.trim().length < 5))" @click="confirmar">
            <v-icon left>mdi-swap-horizontal</v-icon>{{ incierta ? 'Reintentar' : confirmando ? 'Confirmar traslado' : 'Continuar' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="historialVisible" max-width="1000" scrollable>
      <v-card>
        <v-card-title class="traslado-titulo">Historial de traslados<v-spacer /><v-btn icon aria-label="Cerrar historial" title="Cerrar" @click="historialVisible = false"><v-icon>mdi-close</v-icon></v-btn></v-card-title>
        <v-progress-linear v-if="cargandoHistorial" indeterminate />
        <v-card-text><v-alert v-if="errorHistorial" type="error" outlined>{{ errorHistorial }}</v-alert>
          <div class="traslado-lista"><table><thead><tr><th>Fecha</th><th>Usuario</th><th>Origen / ficha</th><th>Destino / ficha</th><th>Envios / boletos</th><th>Motivo</th></tr></thead>
            <tbody><tr v-for="fila in historial" :key="fila.id"><td>{{ fila.fecha }}</td><td>{{ fila.usuario }}</td><td>{{ fila.origen }} / {{ fila.ficha_origen }}</td><td>{{ fila.destino }} / {{ fila.ficha_destino }}</td><td>{{ (fila.envios || []).join(', ') }}<br>Boletos: {{ (fila.boletos || []).join(', ') || '0' }}</td><td>{{ fila.motivo }}</td></tr>
              <tr v-if="!historial.length"><td colspan="6">{{ cargandoHistorial ? 'Cargando...' : 'Sin traslados.' }}</td></tr></tbody>
          </table></div>
        </v-card-text>
        <v-card-actions><v-spacer /><v-btn icon :disabled="!pagina || cargandoHistorial" aria-label="Pagina anterior" title="Anterior" @click="verHistorial(pagina - 1)"><v-icon>mdi-chevron-left</v-icon></v-btn>{{ pagina + 1 }}<v-btn icon :disabled="historial.length < 50 || cargandoHistorial" aria-label="Pagina siguiente" title="Siguiente" @click="verHistorial(pagina + 1)"><v-icon>mdi-chevron-right</v-icon></v-btn></v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { nuevoIdSolicitud } from '../Utilitario/catalogo';

export default {
  name: 'MoverEnvios',
  props: { cajaId: [Number, String], numeroViaje: String, disabled: Boolean },
  data: () => ({ visible: false, origen: '', envios: [], seleccion: [], fecha: '', destinos: [], destinoId: null,
    motivo: '', cargando: false, buscando: false, guardando: false, confirmando: false, incierta: false,
    solicitud: null, error: '', mensaje: '', consultaDestino: 0, historialVisible: false, historial: [],
    cargandoHistorial: false, errorHistorial: '', pagina: 0 }),
  computed: {
    bloqueado() { return this.cargando || this.guardando || this.incierta; },
    elegibles() { return this.envios.filter(e => !this.impedimento(e)); },
    todos() { return this.elegibles.length > 0 && this.elegibles.every(e => this.seleccion.includes(e.id)); },
    asientos() { return this.envios.filter(e => this.seleccion.includes(e.id)).reduce((n, e) => n + Number(e.asientos || 0), 0); },
    destino() { return this.destinos.find(d => d.id === this.destinoId); },
  },
  watch: {
    seleccion() { this.confirmando = false; },
    cajaId() { this.visible = false; this.solicitud = null; this.incierta = false; this.mensaje = ''; },
  },
  methods: {
    opciones(params) { return { headers: this.$store.getters.GetheadersAxios, params, timeout: 30000 }; },
    url(ruta = '') { return this.$hostname + this.$hName + '/transportepv/envios/traslado' + ruta; },
    clavePendiente() { return 'traslado-envios:' + this.opciones().headers['X-TENANT-ID'] + ':' + this.cajaId; },
    impedimento(e) {
      if (e.impedimento) return e.impedimento;
      if (e.is_recogido) return 'Entregado';
      if (e.is_recibido) return 'Recibido';
      if (Number(e.numero_cierre_caja) || Number(e.numero_cierre_caja_destino)) return 'Cierre guardado';
      return '';
    },
    etiquetaDestino(d) { return d.viaje + ' | ' + d.hora + ' | Ficha ' + d.ficha + ' | ' + (d.chofer || ''); },
    seleccionarTodos(marcado) { this.seleccion = marcado ? this.elegibles.slice(0, 100).map(e => e.id) : []; },
    async abrir() {
      this.visible = true; this.error = ''; this.mensaje = ''; this.confirmando = false;
      if (!this.solicitud) {
        try {
          const pendiente = JSON.parse(sessionStorage.getItem(this.clavePendiente()) || 'null');
          if (pendiente) {
            this.solicitud = pendiente.solicitud; this.envios = pendiente.envios || [];
            this.destinos = pendiente.destinos || []; this.destinoId = this.solicitud.destinoId; this.fecha = pendiente.fecha;
          }
        }
        catch (_) { this.solicitud = null; }
      }
      if (this.solicitud) {
        this.incierta = true; this.origen = this.solicitud.origen; this.motivo = this.solicitud.motivo;
        this.seleccion = this.solicitud.ids.slice(); return;
      }
      this.incierta = false; this.origen = String(this.numeroViaje || '').trim(); this.seleccion = []; this.envios = [];
      this.motivo = ''; this.destinos = []; this.destinoId = null;
      const hoy = new Date(); this.fecha = [hoy.getFullYear(), String(hoy.getMonth() + 1).padStart(2, '0'), String(hoy.getDate()).padStart(2, '0')].join('-');
      this.cargando = true;
      try {
        const r = await this.$axios.get(this.url('/contexto'), this.opciones({ cajaId: this.cajaId, origen: this.origen }));
        this.envios = r.data.envios || [];
        await this.buscarDestinos();
      } catch (e) { this.error = this.mensajeError(e); }
      finally { this.cargando = false; }
    },
    cerrar() { if (!this.guardando) this.visible = false; },
    async buscarDestinos() {
      if (this.incierta) return;
      const numero = ++this.consultaDestino;
      this.destinoId = null; this.destinos = []; this.confirmando = false;
      if (!this.fecha) return;
      this.buscando = true;
      try {
        const r = await this.$axios.get(this.url('/destinos'), this.opciones({ cajaId: this.cajaId, origen: this.origen, fecha: this.fecha }));
        if (numero === this.consultaDestino) this.destinos = r.data;
      } catch (e) { if (numero === this.consultaDestino) this.error = this.mensajeError(e); }
      finally { if (numero === this.consultaDestino) this.buscando = false; }
    },
    async confirmar() {
      if (this.guardando || this.cargando || this.buscando) return;
      if (!this.incierta && !this.confirmando) { this.confirmando = true; return; }
      if (!this.solicitud) {
        if (!this.destino || !this.seleccion.length || this.seleccion.length > 100 || this.motivo.trim().length < 5) {
          this.error = 'Seleccione entre 1 y 100 envios, un viaje destino y el motivo.'; return;
        }
        this.solicitud = { cajaId: Number(this.cajaId), origen: this.origen, destinoId: this.destino.id,
          versionDestino: this.destino.version, ids: this.seleccion.slice(), motivo: this.motivo.trim(), idSolicitud: nuevoIdSolicitud() };
      }
      try { sessionStorage.setItem(this.clavePendiente(), JSON.stringify({ solicitud: this.solicitud, envios: this.envios, destinos: this.destinos, fecha: this.fecha })); }
      catch (_) { this.error = 'No se pudo conservar la solicitud para reintentar. Habilite el almacenamiento del navegador.'; this.solicitud = null; return; }
      this.guardando = true; this.error = ''; this.$emit('ocupado', true);
      try {
        const r = await this.$axios.post(this.url(), this.solicitud, this.opciones());
        if (!r.data || r.data.estatus !== 'ok') throw new Error('Respuesta de traslado invalida.');
        this.mensaje = r.data.mensaje; this.limpiarSolicitud(); this.visible = false;
        this.$emit('trasladados', r.data);
      } catch (e) {
        const status = e.response && e.response.status;
        // Only explicit validation/authorization failures are known not to have committed.
        if ([400, 401, 403, 409].includes(status)) { this.limpiarSolicitud(); this.confirmando = false; }
        else this.incierta = true;
        this.error = this.mensajeError(e);
      } finally { this.guardando = false; this.$emit('ocupado', false); }
    },
    limpiarSolicitud() { try { sessionStorage.removeItem(this.clavePendiente()); } finally { this.solicitud = null; this.incierta = false; } },
    mensajeError(e) {
      const data = e.response && e.response.data;
      return (data && (data.message || data.mensaje)) || (typeof data === 'string' ? data : '') || 'No se pudo confirmar la operacion. Revise la conexion y reintente.';
    },
    async verHistorial(pagina) {
      if (this.cargandoHistorial) return;
      this.historialVisible = true; this.cargandoHistorial = true; this.errorHistorial = ''; this.historial = [];
      try {
        const r = await this.$axios.get(this.url('/historial'), this.opciones({ cajaId: this.cajaId, viaje: this.numeroViaje, pagina }));
        this.historial = r.data; this.pagina = pagina;
      } catch (e) { this.errorHistorial = this.mensajeError(e); }
      finally { this.cargandoHistorial = false; }
    },
  },
};
</script>
<style scoped>
.traslado-envios { display: flex; gap: 8px; flex-wrap: wrap; align-items: center; margin: 8px 0; }
.traslado-titulo { font-size: 18px; word-break: normal; }
.traslado-origen { margin-bottom: 12px; }
.traslado-lista { max-height: 300px; overflow: auto; border: 1px solid #cbd5df; }
.traslado-lista table { width: 100%; min-width: 640px; border-collapse: collapse; font-size: 13px; }
.traslado-lista th { background: #edf2f5; text-align: left; position: sticky; top: 0; z-index: 1; }
.traslado-lista th, .traslado-lista td { padding: 8px; border-bottom: 1px solid #d9e1e7; overflow-wrap: anywhere; min-width: 85px; }
.traslado-lista th:first-child, .traslado-lista td:first-child { min-width: 40px; }
.traslado-lista th:last-child, .traslado-lista td:last-child { min-width: 240px; max-width: 360px; white-space: normal; }
.traslado-lista input[type=checkbox] { width: 18px; height: 18px; }
.traslado-destino { display: grid; grid-template-columns: 180px minmax(0, 1fr); gap: 12px; }
.traslado-acciones { flex-wrap: wrap; gap: 8px; justify-content: flex-end; }
.traslado-acciones .spacer { display: none; }
::v-deep .v-btn { letter-spacing: 0; }
@media (max-width: 600px) { .traslado-destino { grid-template-columns: minmax(0, 1fr); } }
</style>
